import Input from "../../../Input";
import { useMaintenanceRegister } from "contexts/register/Maintenance";

import * as S from "./styles";
import { AutoComplete } from "../../../Autocomplete";
import { useDataList } from "hooks/useDataList";
import { IClient } from "interfaces/Client";
import { ToggleButton } from "components/ToggleButton";
import { TextArea } from "components/TextArea";
import { ButtonContainer, InputsContainer } from "./styles";
import { useState } from "react";
import { ISuperficialClient } from "interfaces/SubClient";

export function MaintenanceForm() {
  const { maintenance, setMaintenance, errors, removeError, addError } =
  useMaintenanceRegister();
  
  const { data: clientData} = useDataList<IClient>({
    queryKey: 'listAllClients',
    route: 'clients',
    filter: {
      notPage: true,
    }
  })

  const { data: subClientData} = useDataList<ISuperficialClient>({
    queryKey: 'listSuperficialClients',
    route: 'superficial/clients',
    filter: {
      notPage: true,
      params: {
          client:{ id: maintenance.client?.id }
      },
      relations: {
        client:true
      }
    }
  })
  const [isHeavy, setIsHeavy] = useState<boolean>(false)

  return (
    <S.Wrapper>
      <S.Form>
        <InputsContainer>
        <AutoComplete
          label="Selecione um cliente"
          id="client"
          defaultValue={maintenance?.client}
          isSearchable
          required
          isMulti={false}
          options={clientData?.items ?? []}
          getOptionLabel={(option) => option.name}
          noOptionsMessage={() => 'Nenhum cliente encontrado'}
          placeholder="Selecione um cliente"
          onChange={(item) => {

            if (!item) {
              setMaintenance((value) => {
                value.client = {} as IClient
                return value;
              });
            }

            if (item) {
              setMaintenance((value) => {
                value.client = item as IClient
                return value;
              });
            }
          }}
          onBlur={() => {
            if (!maintenance?.client?.id) {
              addError("noClientSelected", "Necessario selecionar um cliente!")
            } else {
              removeError("noClientSelected")
            }
          }}
          error={errors["client"] || errors["noClientSelected"]}
          apiErrorName={"client"}
          handleApiErrorRemove={() => removeError("client")}
        />
        <AutoComplete
          label="Selecione um sub cliente (opcional)"
          id="subclient"
          defaultValue={maintenance?.superficialClient}
          isSearchable
          isMulti={false}
          options={maintenance?.client ? (subClientData?.items ?? []) : []}
          getOptionLabel={(option) => option.name}
          noOptionsMessage={() => 'Nenhum sub cliente encontrado ou o cliente nao foi selecionado'}
          placeholder="Selecione um sub cliente (opcional)"
          onChange={(item) => {
            if (!item) {
              setMaintenance((value) => {
                value.superficialClient = undefined
                return value;
              });
            }

            if (item) {
              setMaintenance((value) => {
                value.superficialClient = item as ISuperficialClient
                return value;
              });
            }
          }}
        />
        </InputsContainer>
        <InputsContainer>
          <Input
            id="requester"
            name="requester"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.requester = event.target.value;
                return value;
              });
            }}
            label="Solicitante"
            defaultValue={maintenance?.requester}
            required={true}
            type="text"
            error={errors["requester"]}
            apiErrorName={"requester"}
            handleApiErrorRemove={() => removeError("requester")}
          />
          <Input
            id="driver"
            name="driver"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.driver = event.target.value;
                return value;
              });
            }}
            label="Condutor (opcional)"
            defaultValue={maintenance?.driver}
            required={false}
            type="text"
            error={errors["driver"]}
            apiErrorName={"driver"}
            handleApiErrorRemove={() => removeError("driver")}
          />
          <Input
          id="manager"
          name="manager"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setMaintenance((value) => {
              value.manager = event.target.value;
              return value;
            });
          }}
          label="Gestor (opcional)"
          defaultValue={maintenance?.manager}
          required={false}
          type="text"
          error={errors["manager"] || errors["clients.manager"]}
          apiErrorName={"manager"}
          handleApiErrorRemove={() => removeError("manager")}
        />
        </InputsContainer>
        <InputsContainer>
          <Input
            id="plate"
            name="plate"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.plate = event.target.value;
                return value;
              });
            }}
            label="Placa"
            defaultValue={maintenance?.plate}
            required={true}
            type="text"
            error={errors["plate"]}
            apiErrorName={"plate"}
            handleApiErrorRemove={() => removeError("plate")}
          />
          <Input
            id="stopDate"
            name="stopDate"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.stopDate = new Date(event.target.value);
                return value;
              });
            }}
            label="Data para realizar a parada do veículo"
            defaultValue={maintenance?.stopDate? new Date(maintenance.stopDate).toISOString().split('T')[0] : ''}
            required={true}
            type="date"
            //@ts-ignore
            max="9999-12-31"
            error={errors["stopDate"]}
            apiErrorName={"stopDate"}
            handleApiErrorRemove={() => removeError("stopDate")}
          />
        </InputsContainer>
        <AutoComplete
          label="Selecione o tipo de manutenção"
          id="type"
          isMulti={false}
          options={[
            {value:'Preventiva'}, 
            {value:'Corretiva'}, 
            {value:'Colisão'}, 
            {value:'Monitoramento/Rastreador'}]}
          getOptionLabel={(option) => option.value}
          placeholder="Selecione o tipo"
          onChange={(item) => {
            if (!item) {
              setMaintenance((value) => {
                value.type = undefined
                return value;
              });
            }

            if (item) {
              setMaintenance((value) => {
                //@ts-ignore
                value.type = item.value as any
                return value;
              });
            }
          }}
          onBlur={() => {
            if (!maintenance?.type) {
              addError("noTypeSelected", "Necessario selecionar um tipo!")
            } else {
              removeError("noTypeSelected")
            }
          }}
          error={errors["type"] || errors["noTypeSelected"]}
          apiErrorName={"type"}
          handleApiErrorRemove={() => {removeError("noTypeSelected");removeError("type");}}
        />
        <InputsContainer>
        <ButtonContainer>
          <ToggleButton
            label="O Veiculo é de linha pesada?"
            response={!isHeavy}
            onClick={(isTrue) => {
              setIsHeavy(isTrue)
              setMaintenance((value) => {
                value.isHeavy = isTrue;
                return value;
              });
            }}
            leftClick={() => { }}
            rightClick={() => { }}
          />
        </ButtonContainer>
        <Input
          id="KM"
          name="KM"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setMaintenance((value) => {
              value.KM = event.target.value as any;
              return value;
            });
          }}
          label="Quilometragem (opcional)"
          defaultValue={maintenance?.KM}
          required={false}
          type="text"
          error={errors["KM"]}
          apiErrorName={"KM"}
          handleApiErrorRemove={() => removeError("KM")}
        />
        <Input
          id="vehicleBase"
          name="vehicleBase"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setMaintenance((value) => {
              value.vehicleBase = event.target.value;
              return value;
            });
          }}
          label="Base do veículo (opcional)"
          defaultValue={maintenance?.vehicleBase}
          required={false}
          type="text"
          error={errors["vehicleBase"]}
          apiErrorName={"vehicleBase"}
          handleApiErrorRemove={() => removeError("vehicleBase")}
        />
        </InputsContainer>
        <InputsContainer>
          <Input
            id="state"
            name="state"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.state = event.target.value;
                return value;
              });
            }}
            label="Estado"
            defaultValue={maintenance?.state}
            required={true}
            type="text"
            error={errors["state"]}
            apiErrorName={"state"}
            handleApiErrorRemove={() => removeError("state")}
          />
            <Input
              id="city"
              name="city"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setMaintenance((value) => {
                  value.city = event.target.value;
                  return value;
                });
              }}
              label="Cidade"
              defaultValue={maintenance?.city}
              required={true}
              type="text"
              error={errors["city"]}
              apiErrorName={"city"}
              handleApiErrorRemove={() => removeError("city")}
            />

          <Input
            id="contact"
            name="contact"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setMaintenance((value) => {
                value.contact = event.target.value;
                return value;
              });
            }}
            label="Email ou telefone"
            defaultValue={maintenance?.contact}
            required={true}
            type="text"
            error={errors["contact"]}
            apiErrorName={"contact"}
            handleApiErrorRemove={() => removeError("contact")}
          />
        </InputsContainer>

        <TextArea 
          label="Descrição do serviço ou observação" 
          required
          maxLength={1000}
          defaultValue={maintenance?.description}
          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
            if(errors){
              removeError("description");
            }
            setMaintenance((value) => {
              value.description = event.target.value;
              return value;
            });
          }}
          error={errors["description"]}
        />
      </S.Form>
    </S.Wrapper>
  );

}
